import { styled, SvgIcon } from '@mui/material';
import { forwardRef } from 'react';

const CustomSvgIcon = styled(SvgIcon)(({ theme }) => {
    return {
        '&:focus': {
            outline: `${theme.palette.ensightful.secondary[100]} solid 3px`,
        },
    };
});

export default forwardRef((props, ref) => {
    return <CustomSvgIcon ref={ref} {...props} role={'img'} />;
});
